module.exports = __webpack_public_path__ + "static/img/7.46afc50.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/trainPlan/10sportDesc/7.svg
// module id = zbsX
// module chunks = 0